// extracted by mini-css-extract-plugin
export default {"productGallery":"kM-z","inQuickShop":"lM-z"};